module.exports = __webpack_public_path__ + "static/media/illustration-nl.ab359285.png";